import * as _ from 'lodash-es';
import React, { useContext, useEffect, useState } from 'react';
import { SIDEBAR_SHIFT_BREAKPOINT } from '../../post/PostLayoutSizes';
import useGetLayoutBaseWidth from './useGetLayoutBaseWidth';

export const LAYOUT_DEBOUNCE_TIMEOUT = 500;

const ShouldShiftContentForSidebarContext = React.createContext(false);

export const useShouldShiftContentForSidebar = () =>
  useContext(ShouldShiftContentForSidebarContext);

interface SidebarShiftStateProviderProps {
  children: React.ReactNode;
}

const SidebarShiftStateProvider = ({
  children,
}: SidebarShiftStateProviderProps) => {
  const getLayoutBaseWidth = useGetLayoutBaseWidth();

  const [shouldShiftContentForSidebar, setShouldShiftContentForSidebar] =
    useState(() => getLayoutBaseWidth() < SIDEBAR_SHIFT_BREAKPOINT);

  useEffect(() => {
    setShouldShiftContentForSidebar(
      getLayoutBaseWidth() < SIDEBAR_SHIFT_BREAKPOINT,
    );

    let previousWidth = getLayoutBaseWidth();
    const handleResize = _.debounce(() => {
      if (
        previousWidth >= SIDEBAR_SHIFT_BREAKPOINT &&
        getLayoutBaseWidth() < SIDEBAR_SHIFT_BREAKPOINT
      ) {
        setShouldShiftContentForSidebar(true);
      } else if (
        previousWidth < SIDEBAR_SHIFT_BREAKPOINT &&
        getLayoutBaseWidth() >= SIDEBAR_SHIFT_BREAKPOINT
      ) {
        setShouldShiftContentForSidebar(false);
      }
      previousWidth = getLayoutBaseWidth();
    }, LAYOUT_DEBOUNCE_TIMEOUT);

    window.addEventListener('resize', handleResize, { passive: true });
    return () => window.removeEventListener('resize', handleResize);
  }, [getLayoutBaseWidth]);

  return (
    <ShouldShiftContentForSidebarContext.Provider
      value={shouldShiftContentForSidebar}
    >
      {children}
    </ShouldShiftContentForSidebarContext.Provider>
  );
};

export default SidebarShiftStateProvider;
